export default __webpack_public_path__ + "static/media/JobCard4.62e0d4ab.jpeg";